/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown> }} Drastic_Tech_Exporting_File_LogInputs */

const en_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporting ${i?.format} file...`)
};

const fr_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation du fichier ${i?.format}...`)
};

const de_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportiere die Datei ${i?.format}...`)
};

const it_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione del file ${i?.format}...`)
};

const ru_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт файла ${i?.format}...`)
};

const es_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando archivo ${i?.format}...`)
};

const zh_cn2_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在导出${i?.format}文件...`)
};

const ja_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} ファイルをエクスポートしています...`)
};

const hi_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.format} फ़ाइल निर्यात की जा रही है...`)
};

const pt_pt2_drastic_tech_exporting_file_log = /** @type {(inputs: Drastic_Tech_Exporting_File_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando o arquivo ${i?.format}...`)
};

/**
* | output |
* | --- |
* | "Exporting {format} file..." |
*
* @param {Drastic_Tech_Exporting_File_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_exporting_file_log = /** @type {((inputs: Drastic_Tech_Exporting_File_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Exporting_File_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_exporting_file_log(inputs)
	if (locale === "de") return de_drastic_tech_exporting_file_log(inputs)
	if (locale === "it") return it_drastic_tech_exporting_file_log(inputs)
	if (locale === "ru") return ru_drastic_tech_exporting_file_log(inputs)
	if (locale === "es") return es_drastic_tech_exporting_file_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_exporting_file_log(inputs)
	if (locale === "ja") return ja_drastic_tech_exporting_file_log(inputs)
	if (locale === "hi") return hi_drastic_tech_exporting_file_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_exporting_file_log(inputs)
	return en_drastic_tech_exporting_file_log(inputs)
});